<template>
  <div class="container">
    <b-row>
      <b-col class="text-center">
        <h1 class="text-success"><i class="fas fa-check-circle"></i></h1>
        <h3>Venda Finalizada!</h3>
        <h5 class="text-muted">venda número #{{ lastStoredOrder.number }}</h5>
      </b-col>
    </b-row>

    <!-- <b-row v-if="hasModuleNfe" class="mt-3">
      <b-col>
        <button role="button" class="btn btn-block btn-outline-secondary">
          <i class="fas fa-receipt" />
          Emitir NFC-e (F8)
        </button>
      </b-col>
      <b-col>
        <button role="button" class="btn btn-block btn-outline-secondary">
          <i class="fas fa-file-invoice" />
          Emitir NF-e (F9)
        </button>
      </b-col>
    </b-row> -->

    <b-row class="mt-3">
      <b-col
        ><button role="button" class="btn btn-block btn-outline-secondary">
          <i class="fas fa-print" />
          Imprimir (P)
        </button></b-col
      >

      <b-col>
        <button
          @click="newOrder()"
          role="button"
          class="btn btn-block btn-success"
        >
          <i class="fas fa-plus" />
          Novo (F10)
        </button></b-col
      >
    </b-row>
  </div>
</template>

<script>
export default {
  created() {
    window.addEventListener("keydown", e => {
      if (e.key == "p") {
        e.preventDefault();
        this.printOrder();
      }

      if (e.key == "F8") {
        e.preventDefault();
        this.emitNfc();
      }

      if (e.key == "F9") {
        e.preventDefault();
        this.emitNf();
      }
      if (e.key == "F10") {
        e.preventDefault();
        this.newOrder();
      }
    });
  },

  computed: {
    lastStoredOrder() {
      return this.$store.state.orderForm.lastStoredOrder.data;
    },
    hasModuleNfe() {
      if (!this.$store.state.user) {
        return false;
      }

      if (this.$store.state.user.master_user_id != 3) {
        return false;
      }

      return true;
    }
  },

  methods: {
    printOrder() {
      window.open(
        "/vendas/imprimir/cupom/" + this.lastStoredOrder.id,
        "_blank"
      );
    },
    emitNfc() {
      console.log("emitNfc");
    },
    emitNf() {
      console.log("emitNf");
    },
    newOrder() {
      this.$store.commit("orderForm/reset");
      this.$emit("newOrder");
    }
  }
};
</script>
